(() => {
  const selector = '[data-menu-tree-version="2.0"]';
  const mobile = matchMedia('(max-width: 1023px)');
  const menus = () => document.querySelectorAll(selector);
  const summary = details => details.querySelector(':scope > summary');
  const fitBrandPanel = panel => {
    const child = panel.querySelector('[data-lnw2-disclosure="child"][open] > .lnw2-child-panel');
    if (mobile.matches || !panel.classList.contains('lnw2-brands') || !child) {
      panel.style.removeProperty('--lnw2-content-height');
      panel.style.removeProperty('--lnw2-available-height');
      return;
    }
    const top = child.getBoundingClientRect().top;
    const bottom = Math.max(top, ...Array.from(child.children, element => element.getBoundingClientRect().bottom));
    panel.style.setProperty('--lnw2-content-height', `${Math.ceil(bottom - top + 32)}px`);
    panel.style.setProperty('--lnw2-available-height', `${Math.max(0, Math.floor(innerHeight - panel.getBoundingClientRect().top - 16))}px`);
  };
  const update = menu => {
    const root = menu.querySelector(':scope > li > details[open]');
    menu.dataset.drilldown = mobile.matches && root ? 'active' : 'inactive';
    menu.querySelectorAll(':scope > li').forEach(li => li.classList.toggle('lnw2-current-root', li === root?.parentElement));
    // Closed roots need no descendant scans or layout measurements. Include
    // the previously open panel once so its drilldown state is cleared.
    menu.querySelectorAll(':scope > li > details[open] > .lnw2-panel,.lnw2-panel[data-child-open="true"]').forEach(panel => {
      const child = panel.querySelector('[data-lnw2-disclosure="child"][open]');
      panel.dataset.childOpen = String(Boolean(child));
      panel.querySelectorAll('.lnw2-children > li').forEach(li => li.classList.toggle('lnw2-current-child', li === child?.parentElement));
      fitBrandPanel(panel);
    });
  };
  const close = details => {
    details.querySelectorAll('details[open]').forEach(d => {
      if (mobile.matches || d.dataset.lnw2Disclosure !== 'group') d.open = false;
    });
    if (!mobile.matches && details.dataset.lnw2Disclosure === 'group') return;
    details.open = false;
  };
  document.addEventListener('toggle', event => {
    const d = event.target;
    if (!(d instanceof HTMLDetailsElement) || !d.matches('[data-lnw2-disclosure]')) return;
    const menu = d.closest(selector);
    if (!menu) return;
    summary(d)?.setAttribute('aria-expanded', String(d.open));
    if (d.dataset.lnw2Disclosure === 'group' && !d.closest('[data-lnw2-disclosure="root"]')?.open) return;
    if (!mobile.matches && d.dataset.lnw2Disclosure === 'group') {
      if (!d.open) d.open = true;
      update(menu); return;
    }
    if (d.open) {
      const kind = d.dataset.lnw2Disclosure;
      const scope = kind === 'root' ? menu : kind === 'child' ? d.closest('.lnw2-panel') : d.closest('.lnw2-child-panel');
      if (kind !== 'group' || mobile.matches) {
        scope?.querySelectorAll('[data-lnw2-disclosure="' + kind + '"]').forEach(peer => { if (peer !== d) close(peer); });
      }
    } else d.querySelectorAll('details[open]').forEach(close);
    update(menu);
  }, true);
  document.addEventListener('input', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-lnw2-brand-search]')) return;
    const panel = input.closest('.lnw2-panel');
    const needle = input.value.trim().normalize('NFKD').toLocaleLowerCase();
    let visible = 0;
    panel.querySelectorAll('[data-lnw2-brand]').forEach(li => {
      li.hidden = !li.dataset.lnw2Brand.normalize('NFKD').toLocaleLowerCase().includes(needle);
      if (li.hidden) li.querySelectorAll('details[open]').forEach(close);
      else visible++;
    });
    panel.querySelector('[data-lnw2-no-brands]').hidden = visible !== 0;
    update(input.closest(selector));
  });
  document.addEventListener('click', event => {
    const back = event.target.closest?.('[data-lnw2-back]');
    if (back) {
      const d = back.closest('details');
      close(d); update(d.closest(selector));
      summary(d)?.focus({ preventScroll: true });
      return;
    }
    menus().forEach(menu => {
      if (!menu.contains(event.target) && menu.querySelector(':scope > li > details[open]')) { menu.querySelectorAll(':scope > li > details[open]').forEach(close); update(menu); }
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const menu = event.target.closest?.(selector);
    if (!menu) return;
    const d = event.target.closest('[data-lnw2-disclosure][open]');
    if (!d) return;
    event.preventDefault(); event.stopPropagation(); close(d); update(menu); summary(d)?.focus({ preventScroll: true });
  }, true);
  const init = () => {
    const anchor = document.querySelector('[data-lnw2-desktop-anchor]');
    const slot = document.querySelector('[data-lnw2-mobile-slot]');
    const menu = document.querySelector(selector);
    if (menu && anchor && slot) {
      if (mobile.matches) {
        if (menu.parentElement !== slot) slot.append(menu);
        menu.removeAttribute('data-navmenu');
      } else {
        if (menu.previousElementSibling !== anchor) anchor.after(menu);
        menu.setAttribute('data-navmenu', '');
      }
      menu.dataset.menuContext = mobile.matches ? 'mobile' : 'desktop';
      menu.querySelectorAll('[data-lnw2-disclosure="group"]').forEach(d => { if (d.open === mobile.matches) d.open = !mobile.matches; });
    }
    menus().forEach(update);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  mobile.addEventListener('change', () => { menus().forEach(m => m.querySelectorAll('details[open]').forEach(close)); init(); });
  document.addEventListener('shopify:section:load', init);
  let resizeFrame;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => menus().forEach(menu => { if (menu.querySelector(':scope > li > details[open]')) update(menu); }));
  }, { passive: true });
})();
